import {defaultHooks} from 'app/client/DefaultHooks';

export const hooks = defaultHooks;
